import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-box hardware-edit" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1)
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "field field-auto-complete" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "brand" }, "Brand", -1)
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "field field-select" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Type", -1)
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Link", -1)
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { class: "field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, "Date", -1)
const _hoisted_18 = ["textContent"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", null, "Properties", -1)
const _hoisted_20 = { class: "fields" }
const _hoisted_21 = { class: "field field-auto-complete" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Type", -1)
const _hoisted_23 = { class: "field" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "label" }, "Value", -1)
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = { class: "buttons" }
const _hoisted_27 = ["textContent"]

import { computed, onMounted, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import {
  HardwareComponent,
  defaultComponent,
  TypeLabel,
} from '@/models/hardware.model';
import Choice from '@/components/choice/Choice.vue';
import AutoComplete from '@/components/auto-complete/AutoComplete.vue';
import { Actions, Mutations } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'HardwareComponentEdit',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();

const hardware = reactive<HardwareComponent>(
  new HardwareComponent(defaultComponent),
);

const brands = computed<TypeLabel[]>(
  () =>
    store.state.hardwareConfiguration?.brands.map((b: string) => ({
      label: b,
      value: b,
    })) || [],
);

const componentTypes = computed<TypeLabel[]>(
  () => store.state.hardwareConfiguration?.componentTypes || [],
);

const propertyTypes = computed<TypeLabel[]>(
  () => store.state.hardwareConfiguration?.propertyTypes || [],
);

const isEdit = ref<boolean>(false);

const action = computed<string>(() => {
  return isEdit.value ? 'Edit' : 'Add';
});
const title = computed<string>(() => {
  return action.value + ' hardware component';
});

onMounted(async () => {
  store.dispatch(Actions.GetHardwareConfiguration);
  if (~route.path.indexOf('edit') && !store.state.item) {
    // on reload
    isEdit.value = true;
    store
      .dispatch(Actions.GetHardwareComponentByName, route.params.title)
      .then((h) => {
        Object.assign(hardware, h);
      });
  } else if (store.state.item) {
    // on edit from another page
    isEdit.value = true;
    Object.assign(hardware, store.state.item);
  } else {
    // get all purchases first, so that adding a hardware works correctly
    store.dispatch(Actions.GetHardwareComponents);
    Object.assign(hardware, new HardwareComponent(defaultComponent));
  }
});

const cancel = () => {
  store.commit(Mutations.SetViewItem, null);
  router.push('/hardware');
};

const submit = async () => {
  if (hardware.isValid()) {
    const response = await store.dispatch(Actions.UpdateHardwareComponent, {
      item: hardware,
      edit: isEdit.value,
    });
    if (response.status) {
      cancel();
    }
  }
};

const addProperty = () => {
  Object.assign(hardware, {
    ...hardware,
    properties: [...(hardware.properties || []), { type: '', value: '' }],
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", {
      textContent: _toDisplayString(_unref(title))
    }, null, 8, _hoisted_2),
    hardware
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              name: "name",
              autofocus: "",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((hardware.name) = $event))
            }, null, 512), [
              [_vModelText, hardware.name]
            ]),
            (!hardware.isValid('name'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(hardware.validation.messages.name)
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(AutoComplete, {
              id: "brand",
              modelValue: hardware.brand,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((hardware.brand) = $event)),
              items: _unref(brands)
            }, null, 8, ["modelValue", "items"]),
            (!hardware.isValid('brand'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(hardware.validation.messages.brand)
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(Choice, {
              modelValue: hardware.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((hardware.type) = $event)),
              id: "type",
              items: _unref(componentTypes)
            }, null, 8, ["modelValue", "items"]),
            (!hardware.isValid('store'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(hardware.validation.messages.store)
                }, null, 8, _hoisted_12))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "link",
              name: "link",
              autofocus: "",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((hardware.link) = $event))
            }, null, 512), [
              [_vModelText, hardware.link]
            ]),
            (!hardware.isValid('link'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(hardware.validation.messages.link)
                }, null, 8, _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "date",
              id: "date",
              name: "date",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((hardware.date) = $event))
            }, null, 512), [
              [_vModelText, hardware.date]
            ]),
            (!hardware.isValid('date'))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "field-validation",
                  textContent: _toDisplayString(hardware.validation.messages.date)
                }, null, 8, _hoisted_18))
              : _createCommentVNode("", true)
          ]),
          _hoisted_19,
          _createElementVNode("ul", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hardware.properties, (prop, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "property"
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(AutoComplete, {
                    id: "type",
                    modelValue: prop.type,
                    "onUpdate:modelValue": ($event: any) => ((prop.type) = $event),
                    items: _unref(propertyTypes)
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "label",
                    name: "label",
                    autofocus: "",
                    autocomplete: "off",
                    "onUpdate:modelValue": ($event: any) => ((prop.value) = $event)
                  }, null, 8, _hoisted_25), [
                    [_vModelText, prop.value]
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: addProperty
              }, "Add property")
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              class: "cancel",
              onClick: cancel
            }, "Cancel"),
            _createElementVNode("button", {
              type: "submit",
              textContent: _toDisplayString(_unref(action))
            }, null, 8, _hoisted_27)
          ])
        ], 40, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})